import { useMutation } from '@apollo/client'

import { TriggerOrdersPdfExportTasksDocument } from '__generated__/atlas-types'

import { atlasClient } from 'graphql/client'
import { atlas } from 'graphql/tags'

atlas`#graphql
  mutation TriggerOrdersPdfExportTasks($input: TriggerOrdersPdfExportTasksInput!) {
    triggerOrdersPdfExportTasks(input: $input) {
      taskIds
    }
  }
`

export const useTriggerOrderPdfExportTasks = () => {
  const [mutate] = useMutation(TriggerOrdersPdfExportTasksDocument, {
    client: atlasClient,
  })

  return {
    triggerOrderPdfExportTasks: (orderId: string, dueDate?: string) => {
      return mutate({
        variables: {
          input: {
            orderIds: [orderId],
            ...(dueDate && {
              paymentDetails: [
                {
                  orderId,
                  dueDate,
                },
              ],
            }),
          },
        },
      })
    },
  }
}
